'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        plotAreaBackground: {
            type: String,
            kComposite: 'plotArea.background'
        },
        plotAreaBorderColor: {
            type: String,
            kComposite: 'plotArea.border.color'
        },
        plotAreaBorderDashType: {
            type: String,
            kComposite: 'plotArea.border.dashType'
        },
        plotAreaBorderWidth: {
            type: Number,
            kComposite: 'plotArea.border.width'
        },
        plotAreaMargin: {
            type: Number,
            kComposite: 'plotArea.margin'
        },
        plotAreaMarginBottom: {
            type: Number,
            kComposite: 'plotArea.margin.bottom'
        },
        plotAreaMarginLeft: {
            type: Number,
            kComposite: 'plotArea.margin.left'
        },
        plotAreaMarginRight: {
            type: Number,
            kComposite: 'plotArea.margin.right'
        },
        plotAreaMarginTop: {
            type: Number,
            kComposite: 'plotArea.margin.top'
        },
        plotAreaOpacity: {
            type: Number,
            kComposite: 'plotArea.opacity'
        },
        plotAreaPadding: {
            type: Number,
            kComposite: 'plotArea.padding'
        },
        plotAreaPaddingBottom: {
            type: Number,
            kComposite: 'plotArea.padding.bottom'
        },
        plotAreaPaddingLeft: {
            type: Number,
            kComposite: 'plotArea.padding.left'
        },
        plotAreaPaddingRight: {
            type: Number,
            kComposite: 'plotArea.padding.right'
        },
        plotAreaPaddingTop: {
            type: Number,
            kComposite: 'plotArea.padding.top'
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-charts-vue-wrapper/dist/es/KendoChartBase/PlotArea.js
// module id = 685
// module chunks = 0